import { render } from "./TgDivDown.vue?vue&type=template&id=255faad8"
import script from "./TgDivDown.vue?vue&type=script&lang=js"
export * from "./TgDivDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__